import { render, staticRenderFns } from "./CreatedProduct.vue?vue&type=template&id=d84b3bc8&scoped=true"
import script from "./CreatedProduct.vue?vue&type=script&lang=js"
export * from "./CreatedProduct.vue?vue&type=script&lang=js"
import style0 from "./CreatedProduct.vue?vue&type=style&index=0&id=d84b3bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84b3bc8",
  null
  
)

export default component.exports